export default __webpack_public_path__ + "static/media/Advanced Card Securityheader.58d8a983.png";